<div class="bon">
  <header class="bon-head">
    <h1>Bonos</h1>
    <p>Si viste un c&oacute;digo en nuestras redes, escribilo ac&aacute;.</p>
  </header>

  <!-- ============ 1. escribir ============ -->
  <div class="bon-caja" *ngIf="!resultado">
    <label class="bon-campo">
      <span>C&oacute;digo del bono</span>
      <input
        type="text"
        maxlength="24"
        [(ngModel)]="codigo"
        (ngModelChange)="alEscribir()"
        (keyup.enter)="reclamar()"
        placeholder="AGUACATE10"
        autocomplete="off"
        autocapitalize="characters"
      />
      <!-- Se muestra normalizado para que el cliente vea exactamente lo que
           se va a enviar: si escribió con espacios, ve que igual sirve. -->
      <small *ngIf="codigoNormalizado && codigoNormalizado !== codigo">
        Se va a usar as&iacute;: <b class="mono">{{ codigoNormalizado }}</b>
      </small>
    </label>

    <!-- Lo que se sabe del código antes de reclamar. Con el monto y las
         unidades a la vista, nadie siente que perdió el tiempo para que al
         final le digan que se agotó. -->
    <p class="bon-chequeo" *ngIf="consultando">Revisando el c&oacute;digo&hellip;</p>

    <div class="bon-chequeo vale" *ngIf="!consultando && codigoVale && consulta">
      <b>{{ legible(consulta.monto) }} {{ consulta.moneda }}</b>
      <span *ngIf="consulta.unidadesRestantes !== null">
        &middot; quedan {{ consulta.unidadesRestantes }}
      </span>
      <span class="bon-pocas" *ngIf="quedanPocas">&iexcl;&Uacute;ltimos!</span>
    </div>

    <!-- No se distingue "no existe" de "ya termino": el backend responde lo
         mismo para los tres casos, y repetirlo aca seria inventar precision. -->
    <p class="bon-chequeo no" *ngIf="!consultando && codigoNoVale">
      Ese c&oacute;digo no est&aacute; disponible.
    </p>

    <button class="bon-btn" [disabled]="!puedeReclamar || consultando" (click)="reclamar()">
      {{ reclamando ? 'Revisando…' : 'Reclamar el bono' }}
    </button>
  </div>

  <!-- ============ 2 y 3. acreditado / retenido ============ -->
  <!-- Un solo bloque con `exito as e`: la union se estrecha una vez y adentro
       se decide por el estado. Con dos `*ngIf` separados sobre la union,
       `strictTemplates` no puede estrechar el tipo y no compila. -->
  <div class="bon-caja" *ngIf="exito as e" [ngClass]="e.estado === 'ACREDITADO' ? 'ok' : 'espera'">
    <ng-container *ngIf="e.estado === 'ACREDITADO'">
      <span class="bon-icono">&#10003;</span>
      <h2>&iexcl;Listo, el bono ya est&aacute; en tu cuenta!</h2>
      <p class="bon-monto">{{ legible(e.monto) }} <em class="mono">{{ e.moneda }}</em></p>
      <button class="bon-btn plano" (click)="volverAEscribir()">Reclamar otro</button>
    </ng-container>

    <!-- Se dice qué falta y hasta cuándo. Un bono "reservado" sin decir qué
         falta se lee como un bono trabado, y el cliente escribe a soporte. -->
    <ng-container *ngIf="e.estado !== 'ACREDITADO'">
      <span class="bon-icono">&#8987;</span>
      <h2>Tu bono est&aacute; reservado</h2>
      <p class="bon-monto">{{ legible(e.monto) }} <em class="mono">{{ e.moneda }}</em></p>
      <p class="bon-falta">
        Te lo guardamos. Se acredita cuando cumplas la condici&oacute;n de esta
        promoci&oacute;n.
      </p>
      <p class="bon-vence" *ngIf="e.expiraAt">
        Tienes hasta el <b>{{ e.expiraAt | date: 'dd/MM/yyyy' }}</b>.
      </p>
      <button class="bon-btn plano" (click)="volverAEscribir()">Entendido</button>
    </ng-container>
  </div>

  <!-- ============ 4. rechazado ============ -->
  <!-- El texto viene del backend, ya redactado. No se reescribe acá: es el
       mismo que el operador ve en su tablero, así que cuando el cliente dice
       "me aparece que ya reclamé", el operador encuentra esa fila. -->
  <div class="bon-caja no" *ngIf="fallo as f">
    <h2>No pudimos aplicar el bono</h2>
    <p class="bon-motivo">{{ f.mensaje }}</p>

    <a class="bon-btn" *ngIf="mandaAVerificar" routerLink="/wallet/client/user-validation">
      Terminar mi verificaci&oacute;n
    </a>
    <a class="bon-btn" *ngIf="mandaACubrirSaldo" routerLink="/wallet/home">
      Ir a mi cuenta
    </a>

    <button class="bon-btn plano" (click)="volverAEscribir()">Probar otro c&oacute;digo</button>
  </div>

  <!-- ============ mis bonos ============ -->
  <section class="bon-lista" *ngIf="!cargando && bonos.length">
    <h3>Mis bonos</h3>

    <div class="bon-fila" *ngFor="let b of bonos" [class.gris]="b.estado === 'VENCIDO' || b.estado === 'ANULADO'">
      <div class="bon-fila-izq">
        <span class="mono codigo">{{ b.codigo }}</span>
        <span class="bon-pill" [ngClass]="b.estado.toLowerCase()">
          {{ estadoTexto(b.estado) }}
        </span>
      </div>

      <div class="bon-fila-der">
        <span class="bon-fila-monto">{{ legible(b.monto) }} <em class="mono">{{ b.moneda }}</em></span>

        <span class="bon-fila-nota" *ngIf="b.estado === 'RETENIDO'">
          {{ faltaTexto(b) }}
          <ng-container *ngIf="diasParaVencer(b) !== null">
            Quedan {{ diasParaVencer(b) }} d&iacute;as.
          </ng-container>
        </span>

        <span class="bon-fila-nota" *ngIf="b.estado === 'ACREDITADO' && b.acreditadoAt">
          Acreditado el {{ b.acreditadoAt | date: 'dd/MM/yy' }}
        </span>

        <span class="bon-fila-nota" *ngIf="b.estado === 'VENCIDO'">
          Se venci&oacute; sin cumplir la condici&oacute;n.
        </span>
      </div>
    </div>
  </section>

  <p class="bon-vacio" *ngIf="!cargando && !bonos.length && !resultado">
    Todav&iacute;a no reclamaste ning&uacute;n bono.
  </p>
</div>
